module.exports = __webpack_public_path__ + "static/media/Loki 2.143aeb55.jpg";